import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomahabaleshwarcab() {



const cardData = {
  keyword: " Pune to Mahabaleshwar Cab",

"headingDescription": "Pune to Mahabaleshwar Cab service offers a safe, comfortable, and scenic travel experience for passengers planning a trip to the beautiful hill station of Mahabaleshwar. Whether it’s a weekend getaway, family vacation, honeymoon, or corporate trip, our professional drivers and well-maintained vehicles ensure a smooth ride through the Western Ghats. We provide one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. With SRS Pune to Mahabaleshwar Cab, enjoy easy online booking, 24/7 customer support, and a relaxing journey surrounded by nature.",
"topPlaces": [
  {
    "title": "Venna Lake",
    "description": "Venna Lake is one of the most popular attractions in Mahabaleshwar, known for boating and scenic surroundings. Travelers booking Pune to Mahabaleshwar Cab often visit this spot to relax and enjoy the peaceful atmosphere."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is famous for its fresh strawberries, delicious food, and garden setting. Visitors using Pune to Mahabaleshwar Cab enjoy exploring this place for shopping and tasting local products."
  },
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is a well-known viewpoint offering breathtaking views of valleys and mountains. Travelers using Pune to Mahabaleshwar Cab often stop here to capture scenic landscapes and enjoy the cool climate."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is famous for its rock formation resembling an elephant’s head. Visitors traveling via Pune to Mahabaleshwar Cab can admire this unique natural formation and surrounding views."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall is a stunning waterfall surrounded by greenery, especially beautiful during monsoon. Travelers booking Pune to Mahabaleshwar Cab can enjoy nature and photography at this scenic location."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "Mahabaleshwar Temple is an ancient temple dedicated to Lord Shiva and an important spiritual site. Visitors using Pune to Mahabaleshwar Cab often seek blessings and explore its historic architecture."
  },
  {
    "title": "Wilson Point",
    "description": "Wilson Point is the highest point in Mahabaleshwar, offering spectacular sunrise views. Travelers using Pune to Mahabaleshwar Cab visit this spot early morning to enjoy panoramic scenery."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort is a historic fort known for its connection to Chhatrapati Shivaji Maharaj. Visitors traveling via Pune to Mahabaleshwar Cab explore this site for its history and scenic surroundings."
  },
  {
    "title": "Kate’s Point",
    "description": "Kate’s Point provides stunning views of the Dhom Dam and surrounding valleys. Travelers booking Pune to Mahabaleshwar Cab often stop here to enjoy photography and the cool breeze."
  },
  {
    "title": "Table Land (Panchgani)",
    "description": "Table Land in nearby Panchgani is one of the largest plateau viewpoints in Asia. Visitors using Pune to Mahabaleshwar Cab can enjoy horse riding, walking, and panoramic views of the hills."
  }
],



services: [
{
name: "Pune to Mahabaleshwar Cab Booking",
description: "Pune to Mahabaleshwar cab booking offers easy and quick reservation for hill station travel. Customers can book cabs online for one-way or round trips. Comfortable vehicles ensure smooth journeys through scenic ghat roads. Professional drivers ensure safe and timely travel. Transparent pricing ensures budget-friendly fares. Book your Mahabaleshwar cab from Pune for a hassle-free trip."
},
{
name: "Taxi from Pune to Mahabaleshwar",
description: "Taxi from Pune to Mahabaleshwar provides reliable travel for tourists and families. Customers can enjoy comfortable rides with experienced drivers. Scenic routes make the journey enjoyable and refreshing. Flexible booking options are available for all needs. Transparent pricing ensures affordability. Travel conveniently to Mahabaleshwar with taxi services from Pune."
},
{
name: "Pune to Mahabaleshwar Car Hire",
description: "Pune to Mahabaleshwar car hire offers flexible vehicle options for comfortable travel. Customers can choose from sedan, SUV, and luxury cars. Professional drivers ensure safe driving on hill roads. Ideal for family trips and weekend getaways. Transparent pricing ensures value for money. Hire cars from Pune to Mahabaleshwar for a smooth journey."
},
{
name: "Pune to Mahabaleshwar Taxi Service",
description: "Pune to Mahabaleshwar taxi service offers dependable transportation for tourists. Customers can book taxis for one-day or multi-day trips. Comfortable vehicles ensure smooth travel in hilly areas. Professional drivers ensure safe and timely journeys. Transparent pricing ensures fair fares. Choose taxi services for easy travel to Mahabaleshwar."
},
{
name: "Pune to Mahabaleshwar Cab Rental",
description: "Pune to Mahabaleshwar cab rental provides convenient travel options for long-distance trips. Customers can book vehicles for flexible durations. Comfortable cars ensure smooth travel through scenic routes. Professional drivers ensure safe journeys. Transparent pricing ensures affordability. Rent cabs from Pune to Mahabaleshwar for easy travel."
},
{
name: "Pune to Mahabaleshwar Elphinstone Point Car",
description: "Pune to Mahabaleshwar Elphinstone Point car service offers sightseeing travel to famous viewpoints. Customers can explore Elphinstone Point comfortably. Professional drivers ensure safe hill driving. Ideal for tourists and photography trips. Flexible booking options are available. Travel easily to Elphinstone Point from Pune with cab services."
},
{
name: "Pune to Mahabaleshwar Pratapgad Fort Car",
description: "Pune to Mahabaleshwar Pratapgad Fort car service provides convenient travel to historic destinations. Customers can visit Pratapgad Fort with comfortable vehicles. Professional drivers ensure safe hill journeys. Ideal for history lovers and tourists. Flexible booking options are available. Travel from Pune to Pratapgad Fort with cab services."
},
{
name: "Pune to Mahabaleshwar Cab Price",
description: "Pune to Mahabaleshwar cab price service provides clear and transparent fare details. Customers can check pricing before booking rides. Affordable rates ensure budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel experience. Choose cab services with transparent pricing for Mahabaleshwar travel."
},
{
name: "Pune to Mahabaleshwar 2 Days Taxi Fare",
description: "Pune to Mahabaleshwar 2 days taxi fare service offers packages for extended trips. Customers can plan sightseeing and return journeys easily. Comfortable vehicles ensure smooth travel. Professional drivers ensure safe and flexible trips. Transparent pricing ensures affordability. Book 2-day taxi packages from Pune to Mahabaleshwar."
},
{
name: "Book Cab from Pune to Mahabaleshwar",
description: "Book cab from Pune to Mahabaleshwar service allows easy online reservations. Customers can book rides instantly for hill station trips. Professional drivers ensure safe travel. Comfortable vehicles enhance journey experience. Flexible options suit different travel needs. Book your cab easily from Pune to Mahabaleshwar."
},
{
name: "Pune to Mahabaleshwar Cabs",
description: "Pune to Mahabaleshwar cabs provide reliable transportation for tourists and families. Customers can choose from multiple vehicle options. Professional drivers ensure safe journeys on ghat roads. One-way and round trip options are available. Transparent pricing ensures affordability. Travel comfortably with Pune to Mahabaleshwar cab services."
},
{
name: "Pune to Mahabaleshwar Taxi",
description: "Pune to Mahabaleshwar taxi service offers convenient travel for weekend and holiday trips. Customers can book taxis easily. Professional drivers ensure safe and timely journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Enjoy smooth taxi travel from Pune to Mahabaleshwar."
},
{
name: "Pune to Mahabaleshwar Cab Price",
description: "Pune to Mahabaleshwar cab price offers detailed fare information for travelers. Customers can compare prices before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with clear pricing for Mahabaleshwar travel."
},
{
name: "Pune to Mahabaleshwar Distance by Taxi Fare",
description: "Pune to Mahabaleshwar distance by taxi fare provides estimated travel cost based on distance. Customers can plan trips with clear pricing details. Comfortable vehicles ensure smooth journeys. Professional drivers ensure safe travel. Transparent pricing ensures affordability. Travel confidently with fare-based cab services from Pune."
},
{
name: "Pune to Mahabaleshwar Cab for 2 Days",
description: "Pune to Mahabaleshwar cab for 2 days offers flexible travel packages for sightseeing. Customers can explore hill station attractions comfortably. Professional drivers ensure safe travel across routes. Comfortable vehicles enhance journey experience. Transparent pricing ensures value for money. Book 2-day cab services for Mahabaleshwar trips."
},
{
name: "Pune to Mahabaleshwar Car Package",
description: "Pune to Mahabaleshwar car package provides complete travel solutions for tourists. Customers can enjoy planned trips with flexible itineraries. Comfortable vehicles ensure smooth travel. Professional drivers ensure safe journeys. Transparent pricing ensures affordability. Choose car packages for hassle-free Mahabaleshwar travel."
},
{
name: "Pune to Mahabaleshwar Cab Service",
description: "Pune to Mahabaleshwar cab service offers reliable transportation for hill station travel. Customers can book cabs for one-way or round trips. Professional drivers ensure safe journeys on ghat roads. Comfortable vehicles enhance travel experience. Transparent pricing ensures fair fares. Travel easily from Pune to Mahabaleshwar with cab services."
}
],

tableData: [
["Pune to Mahabaleshwar Cab Booking","Taxi from Pune to Mahabaleshwar"],
["Pune to Mahabaleshwar Car Hire","Pune to Mahabaleshwar Taxi Service"],
["Pune to Mahabaleshwar Cab Rental","Pune to Mahabaleshwar Elphinstone Point Car"],
["Pune to Mahabaleshwar Pratapgad Fort Car","Pune to Mahabaleshwar Cab Price"],
["Pune to Mahabaleshwar 2 Days Taxi Fare","Book Cab from Pune to Mahabaleshwar"],
["Pune to Mahabaleshwar Cabs","Pune to Mahabaleshwar Taxi"],
["Pune to Mahabaleshwar Cab Price","Pune to Mahabaleshwar Distance by Taxi Fare"],
["Pune to Mahabaleshwar Cab for 2 Days","Pune to Mahabaleshwar Car Package"],
["Pune to Mahabaleshwar Cab Service","Pune to Mahabaleshwar Cab Booking"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Ghat Section Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Mahabaleshwar ghat roads, ensuring safe driving through winding hill routes and a smooth travel experience."
  },
  {
    WhyChooseheading: "Affordable Pune to Mahabaleshwar Cab Rates",
    WhyChoosedescription: "We offer cost-effective Pune to Mahabaleshwar cab services with transparent pricing. Customers receive complete fare details including tolls and driver charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24 hours for Pune to Mahabaleshwar cab bookings, allowing flexible travel plans for weekend trips, holidays, and early morning departures."
  },
  {
    WhyChooseheading: "Comfortable & AC Hill Travel Vehicles",
    WhyChoosedescription: "Our vehicles are well-maintained, air-conditioned, and suitable for hill travel, providing a comfortable journey from Pune to Mahabaleshwar."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized travel packages for Pune to Mahabaleshwar tours and sightseeing."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers for group trips and family vacations."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "Enjoy easy pickup from homes, hotels, offices, and Pune Airport across all major locations including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Hill Station Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Mahabaleshwar cab bookings due to safe driving, reliable vehicles, and comfortable hill station travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Mahabaleshwar cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Mahabaleshwar with experienced drivers." },
  { question: "How far is Mahabaleshwar from Pune?", answer: "The distance between Pune and Mahabaleshwar is approximately 120 km and the journey takes around 3 to 4 hours." },
  { question: "Is Pune to Mahabaleshwar cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel plans." },
  { question: "Which vehicles are available for Mahabaleshwar trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Mahabaleshwar?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide sightseeing in Mahabaleshwar?", answer: "Yes, we offer local sightseeing packages covering all major points in Mahabaleshwar." },
  { question: "Are vehicles suitable for ghat roads?", answer: "Yes, all vehicles are well-maintained and suitable for hill and ghat driving." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Mahabaleshwar cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Patil",
    feedback:
      "Amazing Pune to Mahabaleshwar cab service. Driver handled ghat roads very well and journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Kavita Sharma",
    feedback:
      "Booked SRS Cab Service for family trip to Mahabaleshwar. Very comfortable ride and great service.",
    rating: 5
  }
];


































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mahabaleshwar Cab | SRS Cab",
  "description": "SRS Cab offers Pune to Mahabaleshwar cab services including taxi bookings, car hire, and cab rentals. Visit Elphinstone Point, Pratapgad Fort, and other scenic destinations. Book one-way, round trip, or 2-day packages with transparent fares. Enjoy safe, comfortable, and punctual rides with 24x7 online booking from Pune to Mahabaleshwar.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Mahabaleshwar Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Mahabaleshwar cabs with SRS Cab. Taxi service, car hire, cab rental for one-way, round trips, or 2-day packages. Visit Elphinstone Point, Pratapgad Fort with 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomahabaleshwarcab;